/** Distinct palette for Recharts pies, bars, and legends (cycles for long lists). */
export const CHART_COLORS = [
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#8884d8",
    "#83a6ed",
    "#8dd1e1",
    "#82ca9d",
    "#a4de6c",
    "#d0ed57",
    "#bc5090",
    "#ff6b6b",
    "#4ecdc4",
    "#45b7d1",
    "#96ceb4",
];
